module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAArklEQVR4AWMYHCAxR/+/0FptkjHcgAtCJv9dWnTJN+CSgMn/45LG/3Wn65BvAAjf0Nb9/+cw8///5xjg+PMRBhT+z5NwNqoBMHzPUf3/vzOMcEUJfqgGNGbgNACBnybI/f9zhuF/TjhIEYT+eYrhf1EMhF+XRsgFpyAuWNTM8H9CCZgG87dMZPg/p47h/96ZYD6OMDjIApIkBmPGgv5UCmLBrZmCdJCcTWZKHB4AAHSqSzHxR8xiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/ST.png
// module id = 1270
// module chunks = 0